export const AUTO_ORDER = 1;
export const PAW_POINT = 1;
export const CREDIT_CARD = 0;

export enum FoodType {
  DOG = 1,
  CAT = 2,
  DEFAULT = 0,
}

export enum PaymentType {
  CREDIT_CARD = 0,
  PAW_POINT = 1,
  SAMPLE_CREDIT = 2,
}

export enum ItemTypes {
  NORMAL_ORDER = 0,
  AUTO_ORDER = 1,
}

export enum Species {
  DOG = 1,
  CAT = 2,
}

export enum CustomerTypes {
  RETAIL_CUSTOMER = 1,
  PAW_CLUB = 2,
  PET_PRO = 3,
  FORMER_PET_PRO = 4,
  TEST_USER = 5,
  EMPLOYEE = 6,
  PROSPECT = 7,
}

export enum AvatarType {
  TINY = 0,
  SMALL = 1,
  DEFAULT = 2,
  LARGE = 3,
}

export enum ShoppingFlowType {
  PetQuiz = 1,
  EnrollmentCheckout = 2,
  RegularShopping = 3,
  EZShipManagerShopping = 4,
  ShoppableLandingPages = 6,
  RecommendationPages = 7,
  CustomerService = 8,
  Miscellaneous = 9,
}
